import React from 'react';
import { Outlet } from 'react-router-dom';

export function LabelLayout({
  children
}) {
  return (
    <Outlet />
  )
}